import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
import { getQueryString } from '@/utils/common'
export const queryHistoryPointList = async (params: object) => {
  return await GET({
    url: Api.queryHistoryPointList,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      cityId: getQueryString('cityId'),
      token: getQueryString('token'),
      date: getQueryString('date'),
      ...params
    },
    showError: false
  })
}
